export default "__VITE_ASSET__ae8dfa60__"